export default class TrueengageLogger {
  constructor() {
    this.prefix = '[TE]'
    this.levels = {
      debug: 1,
      info: 2,
      warn: 3,
      error: 4,
    }

    const localLogLevel = localStorage.getItem('trueengage-logLevel')
    this.setLogLevel(localLogLevel || 'warn')
  }

  setLogLevel(level) {
    if (this.levels[level] === undefined) {
      console.error(this.prefix, 'Invalid log level')
      return
    }
    this.logLevel = level
  }

  time(message) {
    if (this.levels[this.logLevel] <= this.levels['info']) {
      console.time(`${this.prefix} ${message}`)
    }
  }

  timeEnd(message) {
    if (this.levels[this.logLevel] <= this.levels['info']) {
      console.timeEnd(`${this.prefix} ${message}`)
    }
  }

  info(message) {
    if (this.levels[this.logLevel] <= this.levels['info']) {
      console.info(this.prefix, message)
    }
  }

  debug(message) {
    if (this.levels[this.logLevel] <= this.levels['debug']) {
      console.debug(this.prefix, message)
    }
  }

  warn(message) {
    if (this.levels[this.logLevel] <= this.levels['warn']) {
      console.warn(this.prefix, message)
    }
  }

  error(message) {
    if (this.levels[this.logLevel] <= this.levels['error']) {
      console.error('[TE] ', message)
    }
  }
}
